import { Inter_Tight } from "next/font/google";

export const mainFont = Inter_Tight({
  subsets: ["latin"],
  weight: ["400", "500", "700"],
  display: "swap",
});
